import type { ImageProps, StaticImageData } from 'next/image'
import Image from 'next/image'

import { useNotification } from '@/containers'

const ImageOptimize = ({
  alt,
  thumbnail = false,
  ...rest
}: ImageProps & {
  alt: string
  thumbnail?: boolean
  lazyLoad?: boolean
}) => {
  const { systemConfig } = useNotification()

  const qtt = systemConfig?.imageQlt || 70
  const width = systemConfig?.imageThumbWidthDesktop || 275
  const thumb = thumbnail ? `&width=${width}` : ''

  let srcStr = ''

  if (rest.src) {
    srcStr =
      typeof rest.src === 'string'
        ? rest.src
        : (rest.src as StaticImageData).src

    srcStr = srcStr.replace('pico.vn', 'dienmaykho.vn')
    srcStr = `${srcStr}?format=webp&quality=${qtt}${thumb}`
  } else {
    srcStr =
      systemConfig?.imageWarehousePlaceholder ||
      process.env.NEXT_PUBLIC_IMAGE_PLACEHOLDER ||
      ''
  }

  return (
    <Image
      {...rest}
      className={`${rest.className || ''} imgOtm`}
      alt={alt || 'Điện Máy Kho'}
      width={rest.width ?? 0}
      height={rest.height ?? 0}
      sizes='100%'
      src={srcStr}
      loading={rest.priority ? 'eager' : 'lazy'}
    />
  )
}

export default ImageOptimize
